<template>
  <main class="bg-background-neutral-primary flex min-h-screen w-full flex-col">
    <section
      class="bg-background-neutral-primary sticky top-0 z-20 w-full flex-shrink-0"
      style="padding-top: var(--status-bar-height)"
    >
      <slot name="header" />
    </section>
    <section
      class="flex flex-grow flex-col px-4"
      style="padding-bottom: var(--content-padding-bottom, 16px)"
    >
      <slot />
    </section>
  </main>
</template>
